import { useIntl } from 'umi';
import { Modal, Button, Form, Input, Radio, notification } from 'tea-component';
import { useForm, useField } from 'react-final-form-hooks';
import React, { useEffect } from 'react';
import { isValidEmail } from '@home/pages/login/_config/common';
import type { ReceiverItem, BatchAddUserModalProps, FormValues } from './type';

const BatchAddUserModal: React.FC<BatchAddUserModalProps> = (props) => {
  const { batchAddModalInfo: { type, isVisible }, onClose, onConfirm, receiverList} = props;
  const { formatMessage } = useIntl();

  // 邮箱校验
  const validEmailStr = (emails: string[], receiverList: ReceiverItem[]) => {
    const formatErrList: string[] = [];

    // 1、检查格式错误
    emails.forEach((email) => {
      if (!isValidEmail(email)) {
        formatErrList.push(email);
      }
    });

    if (formatErrList.length > 0) {
      notification.error({
        description: `${formatMessage({ id: 'subscribe_enter_valid_email' })}: ${formatErrList.join(', ')}`,
      });
      return false;
    }

    // 2、检查是否存在于 receiverList
    const receiverEmails = receiverList?.map((r) => r.email);
    const unMatchList = emails.filter((email) => !receiverEmails.includes(email));

    if (unMatchList.length > 0) {
      notification.error({
        description: `${formatMessage({ id: 'subscribe_email_not_exist' })}: ${unMatchList.join(', ')}`,
      });
      return false;
    }

    return true;
  };

  // 用户名校验
  const validUsername = (usernames: string[], receiverList: ReceiverItem[]) => {
  
    // 检查用户名是否存在于 receiverList
    const receiverUsername = receiverList?.map((r) => r.text);
    const unMatchList = usernames.filter((text) => !receiverUsername.includes(text));
  
    if (unMatchList.length > 0) {
      notification.error({
        description: `${formatMessage({ id: 'subscribe_username_not_exist' })}: ${unMatchList.join(', ')}`,
      });
      return false;
    }
  
    return true;
  };


  // 表单提交
  function onSubmit(val: FormValues) {
    const dealData = val.account_str.replace(/[\n；]/g, ';').split(';');
    const submitInfo = dealData
      .filter((item: string) => !!item.trim())
      .map((item: string) => item.trim());

    const isEmail = type === 'email' || val.field_type === 'email';

    if (isEmail) {
      if (!validEmailStr(submitInfo, receiverList)) return;

      // 根据邮箱找到对应 value
      const mappedValues = submitInfo
        .map((email: string) => {
          const found = receiverList.find((r) => r.email === email);
          return found ? found.value : null;
        })
        .filter((val): val is string | number => val !== null);

      return onConfirm(mappedValues);
    }

    // 用户名逻辑
    if (!validUsername(submitInfo, receiverList)) return;

    const mappedValues = submitInfo
      .map((text: string) => {
        const found = receiverList.find((r) => r.text === text);
        return found ? found.value : null;
      })
      .filter((val): val is string | number => val !== null);

    onConfirm(mappedValues);
  }


  const { form, handleSubmit } = useForm({
    onSubmit,
    initialValuesEqual: () => true,
    initialValues: {
      field_type: type === 'email' ? 'email' : 'user_name',
      account_str: '',
    },
  });
  const field_type = useField('field_type', form);
  const account_str = useField('account_str', form);

  // 保存
  function onOk() {
    handleSubmit();
  }

  useEffect(() => {
    form?.change('account_str','');
  }, [isVisible, form]);
  

  return (
    <Modal
      visible={isVisible}
      size="l"
      caption={formatMessage({ id: 'subscribe_batch_add' })}
      onClose={onClose}
    >
      <Modal.Body>
        <Form>
          <Form.Item label={formatMessage({ id: 'subscribe_account_type' })} showStatusIcon={false}>
            <Radio.Group
              {...field_type.input}
              onChange={value => {
                field_type.input.onChange(value);
              }}
              disabled={type === 'email'}
            >
              <Radio name="user_name">{formatMessage({ id: 'subscribe_username' })}</Radio>
              <Radio name="email">{formatMessage({ id: 'subscribe_manager_push_method_email' })}</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label={
              field_type.input.value === 'email'
                ? formatMessage({ id: 'subscribe_manager_push_method_email' })
                : formatMessage({
                  id: 'subscribe_username',
                })
            }
            showStatusIcon={false}
          >
            <Input.TextArea
              size="full"
              {...account_str.input}
              style={{ height: 500 }}
              placeholder={formatMessage({
                id: 'subscribe_batch_add_placeholder',
              })}
            />
          </Form.Item>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={onOk} disabled={!account_str.input.value.trim()}>
          {formatMessage({ id: 'Confirm' })}
        </Button>
        <Button type="weak" onClick={onClose}>
          {formatMessage({ id: 'Cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BatchAddUserModal;
